import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-send-detail',
  templateUrl: './send-detail.component.html',
  styleUrls: ['./send-detail.component.scss']
})
export class SendDetailComponent {

  @Input() message: any;
  @Output() back = new EventEmitter<void>();
  @Output() resend = new EventEmitter<any>();
  @Output() moveToTrash = new EventEmitter<any>();

  constructor(private sanitizer: DomSanitizer) {}

  get safeContent(): SafeHtml {
    if (!this.message?.content) return '';
    return this.sanitizer.bypassSecurityTrustHtml(this.message.content);
  }

  get etatLabel(): string {
    const labels: Record<string, string> = {
      'ENVOYE': 'Envoyé',
      'ATTENTE': 'En attente',
      'CORBEILLE': 'En attente de suppression',
      'NON-ENVOYE': 'Non envoyé'
    };
    return labels[this.message?.etat] || 'Non défini';
  }

  get etatClass(): string {
    const classes: Record<string, string> = {
      'ENVOYE': 'success',
      'ATTENTE': 'warning',
      'CORBEILLE': 'danger',
      'NON-ENVOYE': 'secondary'
    };
    return classes[this.message?.etat] || 'secondary';
  }

  get typeLabel(): string {
    return this.message?.type === 'MAIL' ? 'Mail' : 'SMS';
  }

  onBack(): void {
    this.back.emit();
  }

  onResend(): void {
    this.resend.emit(this.message);
  }

  onMoveToTrash(): void {
    this.moveToTrash.emit(this.message);
  }
}
